import React from "react";
import { useGetEwalletBalanceQuery } from "../../app/features/apiSlice";
import wallet from "../../assets/images/wallet.webp";
import { useTranslation } from "react-i18next";
import SmallCards from "./SmallCards";
import { SkSmallCard } from "../Skeleton";
import CurrencyValue from "../CurrencyValue";

const EwalletCard = () => {
  const { t } = useTranslation();
  const sessionId = React.useRef(Date.now()).current;
  const [currBalance, setCurrBalance] = React.useState(0);
  const { data, isLoading, isError, error, isSuccess } =
    useGetEwalletBalanceQuery({
      sessionId,
    });

  React.useEffect(() => {
    if (isSuccess) {
      const value = data?.totals?.currentBalanceAvailable || 0;
      setCurrBalance(value);
    }
  }, [data, isSuccess]);

  if (isError) {
    console.error("Error fetching eWallet balance:", error);
  }
  return (
    <SmallCards
      imgSrc={wallet}
      title={t("eWalletBalance")}
      number={
        isLoading ? <SkSmallCard /> : <CurrencyValue amount={currBalance} />
      }
      tooltipText={t("totalEWalletBalance")}
    />
  );
};

export default EwalletCard;
